module.exports = __webpack_public_path__ + "static/media/EU.679156e4.svg";